// @file Entrypoint for auth signup page
import { captureException } from 'bits/error_tracker'
import { ww } from 'bits/global'
import { setupVueApp } from 'bits/vue'
import AuthSignupApp from 'vuecomponents/AuthSignupApp.vue'
import { storeOptions } from 'vuexstore/landside'

void setupVueApp({
  el: '#auth_signup_app',
  rootComponent: AuthSignupApp,
  storeOptions,
  initializeStore(store): void {
    store.dispatch('initializeState', ww.vueStartingState).catch(captureException)
  },
})
